import { useEffect, useState } from 'react';
import { FaTimes, FaDownload } from 'react-icons/fa';

// Top-right "Install app" popup. Shows when the browser fires
// beforeinstallprompt (Chrome/Edge/Android), or an Add-to-Home-Screen hint on
// iOS Safari. Dismissal is remembered so it doesn't nag.
const DISMISS_KEY = 'qz_pwa_dismissed';

export default function PWAInstall() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;

    // Already installed / running standalone? Don't show.
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    if (standalone) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    const onInstalled = () => {
      setShow(false);
      setDeferred(null);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);

    // iOS Safari has no beforeinstallprompt — show the manual hint instead.
    const ua = window.navigator.userAgent;
    const isIos = /iphone|ipad|ipod/i.test(ua);
    const isSafari = /safari/i.test(ua) && !/crios|fxios|edgios/i.test(ua);
    if (isIos && isSafari) {
      setIos(true);
      setShow(true);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try {
      await deferred.userChoice;
    } catch (e) {
      /* ignore */
    }
    setDeferred(null);
    setShow(false);
  };

  const dismiss = () => {
    setShow(false);
    localStorage.setItem(DISMISS_KEY, '1');
  };

  if (!show) return null;

  return (
    <div className="fixed top-[68px] right-3 sm:right-5 z-40 w-[270px] max-w-[calc(100vw-1.5rem)] surface-card rounded-2xl p-3 pop-in shadow-xl flex items-start gap-3">
      <img src="/icon-192.png" alt="" className="w-11 h-11 rounded-xl shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-black text-slate-900 leading-tight">Install QuizzyLoot</p>
        {ios ? (
          <p className="text-[11px] text-slate-500 mt-0.5 leading-snug">
            Tap <span className="font-bold">Share</span> →{' '}
            <span className="font-bold">Add to Home Screen</span>.
          </p>
        ) : (
          <>
            <p className="text-[11px] text-slate-500 mt-0.5 leading-snug">
              Add it to your home screen for one-tap access.
            </p>
            <button
              onClick={install}
              className="btn-3d mt-2 inline-flex items-center gap-1.5 rounded-xl bg-brand hover:bg-brand-dark px-4 py-2 text-xs font-black uppercase tracking-wide text-white"
            >
              <FaDownload /> Install
            </button>
          </>
        )}
      </div>
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        className="text-slate-400 hover:text-slate-700 shrink-0"
      >
        <FaTimes />
      </button>
    </div>
  );
}
